import AdminUserModel from "../../domain/models/adminUser.model";
import BaseApi from "../api/base.api";

class UserService {
  private baseApi: BaseApi;
  private uri: string;

  constructor() {
    this.baseApi = new BaseApi();
    this.uri = "user";
  }

  public getAdminUsers = async (): Promise<AdminUserModel[]> => {
    const response = await this.baseApi.apliClient.get<AdminUserModel[]>(
      `${this.uri}/admin/parents`
    );
    return response.data;
  };
}

export default UserService;
